// src/components/ui/calendar/week/WeekViewTimeRow/WeekViewTimeRow.jsx
import React from 'react';
import { cn } from '../../../../../utils/cn';
import { CalendarHourLabel } from '../../core';
import WeekViewTimeSlot from '../WeekViewTimeSlot/WeekViewTimeSlot';

const WeekViewTimeRow = ({
  hour,
  weekDates,
  onTimeSlotClick,
  getEventsForTimeSlot,
  getBackgroundEventsForTimeSlot,
  isAdmin = false,
  children, // For custom time slot content
  className = '',
  availabilityDates,
  viewingPartnerAvailability,
  // Block mode props
  isBlockMode = false,
  persistedSlots = [],
  currentDragSlots = [],
  onSlotMouseDown,
  onSlotMouseEnter,
}) => {
  return (
    <div className={cn(
      "flex border-b border-slate-600/20 h-16",
      className
    )}>
      {/* Hour label */}
      <CalendarHourLabel hour={hour} />

      {/* Day columns container */}
      <div className="flex-1 grid grid-cols-7">
        {weekDates.map((date, dayIndex) => {
          const timeSlotEvents = getEventsForTimeSlot ? getEventsForTimeSlot(date, hour) : [];
          const backgroundEvents = getBackgroundEventsForTimeSlot ? getBackgroundEventsForTimeSlot(date, hour) : [];

          // FIXED: Calculate hasAvailability (same as MonthView/DayView)
          const dateStr = date.toISOString().split('T')[0];
          const hasAvailability = viewingPartnerAvailability && availabilityDates && availabilityDates.has(dateStr);

          const isSelected = isBlockMode &&
            persistedSlots.some(s => s.dateStr === dateStr && s.hour === hour);
          const isDragHighlighted = isBlockMode &&
            currentDragSlots.some(s => s.dateStr === dateStr && s.hour === hour);

          return (
            <WeekViewTimeSlot
              key={dayIndex}
              date={date}
              hour={hour}
              dayIndex={dayIndex}
              events={timeSlotEvents}
              backgroundEvents={backgroundEvents}
              isClickable={isAdmin && !isBlockMode}
              onClick={onTimeSlotClick}
              hasAvailability={hasAvailability}
              viewingPartnerAvailability={viewingPartnerAvailability}
              isBlockMode={isBlockMode}
              isSelected={isSelected}
              isDragHighlighted={isDragHighlighted}
              onMouseDown={isBlockMode && onSlotMouseDown ? () => onSlotMouseDown(date, hour) : undefined}
              onMouseEnter={isBlockMode && onSlotMouseEnter ? () => onSlotMouseEnter(date, hour) : undefined}
            >
              {/* Custom slot content or events */}
              {children ? children(date, hour, dayIndex) : null}
            </WeekViewTimeSlot>
          );
        })}
      </div>
    </div>
  );
};

export default WeekViewTimeRow;